$(document).ready(function () {
  $(document).on('click', '.clients-momentum-planning-competitive-analysis-component .radio-buttons__option', function () {
    const component = $(this).closest('.clients-momentum-planning-competitive-analysis-component'); // Update yes-no radio button values back to section
    const id = component.attr('momentum_competitive_analysis_section_id'); // Id of the section
    const property = $(this).attr('attr'); // Which radio is getting clicked
    const value = $(this).attr('value'); // Value of the radio button
    updateCompetitiveAnalysisSection(id, property, value);
  });

  function updateCompetitiveAnalysisSection(id, property, value) {
    $.post('/components/clients/momentum_sections/competitive_analysis', {
      id: id,
      property: property,
      value: value
    }).done(function (data) {

      if (data.success) {
        window.reloadConfirmationDayReadinessAssessmentComponent();
        window.reloadMomentumSectionPlanningTab(data.section_completion_percentage, 'competitive_analysis');
        window.reloadClientTaskBinComponents();
      }
    });
  }
});
